import React, { useState } from "react";
import { Lock } from "lucide-react";
import { http, ACCESS_KEY, formatApiError } from "./resourceUtils";

export const AccessGate = ({ onUnlocked }) => {
    const [code, setCode] = useState("");
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError("");
        try {
            const { data } = await http.post("/client-resources/unlock", { code });
            if (data.token) localStorage.setItem(ACCESS_KEY, data.token);
            onUnlocked();
        } catch (err) {
            setError(formatApiError(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="res-card mx-auto max-w-md p-10 text-center" data-testid="access-gate">
            <Lock size={26} strokeWidth={1.2} className="mx-auto" style={{ color: "#CFA969" }} aria-hidden />
            <h2 className="mt-5 font-serif text-[32px]" style={{ color: "#4A4A30" }}>Enter your access code</h2>
            <p className="mt-3 text-[16px] leading-[1.7]" style={{ color: "#5C5C47" }}>
                Austine shares this code with clients during sessions.
            </p>
            <form onSubmit={submit} className="mt-8 space-y-4">
                <label htmlFor="access-code" className="sr-only">Access code</label>
                <input
                    id="access-code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    className="res-input text-center !pl-5"
                    placeholder="Access code"
                    autoComplete="off"
                    data-testid="access-code-input"
                />
                {error && <p role="alert" className="text-[15px]" style={{ color: "#9A4557" }} data-testid="access-code-error">{error}</p>}
                <button type="submit" disabled={busy || !code.trim()} className="res-btn justify-center w-full disabled:opacity-60" data-testid="access-code-submit">
                    {busy ? "Checking..." : "View resources"}
                </button>
            </form>
        </div>
    );
};
